import { StatsTimePeriod } from '../../../../types/statsSection';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';

export const routes = [
  {
    hash: 'overview',
    transKey: 'pages.stats.widgets.overview.title',
  },
  {
    hash: 'my_submissions',
    transKey: 'pages.stats.widgets.my_submissions.title',
  },
  { hash: 'traffic', transKey: 'pages.stats.widgets.traffic.title' },
  { hash: 'general', transKey: 'pages.stats.widgets.general.title' },
];

export const timePeriods = [
  {
    index: StatsTimePeriod.Week,
    labelTransKey: 'pages.stats.week',
    biData: {
      evid: BiEventType.STATS_CHANGE_LEVEL_CLICK,
      time_period: StatsTimePeriod.Week,
    },
  },
  {
    index: StatsTimePeriod.Month,
    labelTransKey: 'pages.stats.month',
    biData: {
      evid: BiEventType.STATS_CHANGE_LEVEL_CLICK,
      time_period: StatsTimePeriod.Month,
    },
  },
  {
    index: StatsTimePeriod.Year,
    labelTransKey: 'pages.stats.year',
    biData: {
      evid: BiEventType.STATS_CHANGE_LEVEL_CLICK,
      time_period: StatsTimePeriod.Year,
    },
  },
];
